module.exports = __webpack_public_path__ + "img/gnzs26.7efca6d5.png";